import pinService from "../pin-service";

import { createFiltersService } from "./factory";

const filtersService = createFiltersService(pinService);

export default filtersService;
